import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

import { tripRequiredFieldOptions } from './tripRequiredFieldOptions';

interface RequiredTripFieldSelectProps {
  label: string;
  name: string;
}

const formFieldNamePrefix = 'trip_required_fields';

export function RequiredTripFieldSelect({
  label,
  name,
}: RequiredTripFieldSelectProps) {
  return (
    <FormFieldController name={`${formFieldNamePrefix}.${name}`}>
      {({ field }) => {
        return (
          <FormField
            label={label}
            type="select"
            inputProps={{
              ...field,
              id: name,
            }}
            onChange={(e) => {
              field.onChange(e);
            }}
            options={tripRequiredFieldOptions}
            value={field.value}
          />
        );
      }}
    </FormFieldController>
  );
}
